// Ionic Angular
import { Component, ViewEncapsulation , OnInit} from '@angular/core';
import { Events } from 'src/providers/events/events';
import { Client } from 'src/providers/client/client';
import { MenuData } from './models/menu-data';
import { Customer } from 'src/providers/customer/customer';
import { Me } from 'src/providers/me/me';
import { parseMenuData } from './parsers/menu-data-parser';
import { Router, NavigationEnd } from '@angular/router';
import { Logger } from 'src/providers/logger';


@Component({
    selector: 'tidy-menu',
    templateUrl: 'tidy-menu.html',
    styleUrls: ['./tidy-menu.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TidyMenuComponent implements OnInit {
  openState: Boolean = false;
  nameAndAddress: any;
  menuData: MenuData;

  constructor(
    private client: Client,
    private customer: Customer,
    private events: Events,
    private logger: Logger,
    private me: Me,
    private router: Router
  ) {

  }

  async ngOnInit() {
    await this.fetchAddressData();
    this.listenRoutes();
  }

  async fetchAddressData(route = null) {
    try {
      const me = await this.me.load();
      const settings = await this.customer.settings();
      const addresses = await this.client.getAddresses();
      const currentAddressId = this.getAddressSelected();
      this.menuData = parseMenuData(me, settings, addresses, currentAddressId, route);
    } catch (err) {
      this.logger.error(err);
    }
  }

  changeState() {
    this.menuData.openState = !this.menuData.openState;
  }

  getAddressSelected() {
    const addressId = parseInt(localStorage.getItem('addressId'));
    if (!addressId) {
      this.events.publish('menu:close');
    }
    return addressId;
  }

  listenRoutes() {
    this.router.events.subscribe(async event => {
      if (event instanceof NavigationEnd) {
        await this.fetchAddressData(this.router.url);
      }
    });
  }
}
